import React, { ChangeEvent, useState } from 'react';
import Input from 'ui/Input';
import { useTranslations } from 'next-intl';
import ButtonWrapper from 'ui/ButtonWrapper';
interface AddressFieldConfig {
  name: string;
  id: string;
  label: string;
  placeholder: string;
}

interface AddressInputsProps {
  address: string;
  addressTwo?: string;
  addressConfig: AddressFieldConfig;
  addressTwoConfig: AddressFieldConfig;
  errors?: {
    address?: string;
  };
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  addressClassName?: string;
  addressTwoClassName?: string;
  labelClassName?: string;
}

const AddressInputs = ({
  address,
  addressTwo,
  addressConfig,
  addressTwoConfig,
  errors = {},
  onChange,
  addressClassName = 'col-span-1 sm:col-span-6',
  addressTwoClassName = 'col-span-1 sm:col-span-6',
  labelClassName = '',
}: AddressInputsProps) => {
  const [showAddressTwo, setShowAddressTwo] = useState(false);
  const tCommon = useTranslations('common');
  return (
    <>
      <div className={addressClassName}>
        <div className="flex flex-col sm:flex-row sm:items-center sm:gap-4">
          <div className="flex-grow">
            <Input
              type="text"
              name={addressConfig.name}
              id={addressConfig.id}
              label={addressConfig.label}
              placeholder={addressConfig.placeholder}
              value={address}
              onChange={onChange}
              errorMessage={errors.address}
              labelClassName={labelClassName}
            />

            {/* Line with text for mobile - now below input */}
            {!showAddressTwo && (
              <div className="sm:hidden mt-2">
                <button
                  type="button"
                  className="text-left text-sm text-gray-500"
                  onClick={() => setShowAddressTwo(true)}
                >
                  <span className="inline-block border-b border-gray-200">
                    {tCommon('addAddressLineTwo')}
                  </span>
                </button>
              </div>
            )}
          </div>

          {/* Button for desktop - stays on the right */}
          {!showAddressTwo && (
            <div className="hidden sm:block mt-6 min-w-fit whitespace-nowrap">
              <ButtonWrapper
                type="button"
                theme="gray"
                onClick={() => setShowAddressTwo(true)}
                aria-label={tCommon('addAddressLineTwo')}
              >
                {tCommon('addAddressLineTwo')}
              </ButtonWrapper>
            </div>
          )}
        </div>
      </div>
      {showAddressTwo && (
        <div className={addressTwoClassName}>
          <Input
            type="text"
            name={addressTwoConfig.name}
            id={addressTwoConfig.id}
            label={addressTwoConfig.label}
            placeholder={addressTwoConfig.placeholder}
            value={addressTwo}
            onChange={onChange}
            labelClassName={labelClassName}
          />
        </div>
      )}
    </>
  );
};

export default AddressInputs;
